if (!customElements.get('mercy-detail-film')) {
  customElements.define('mercy-detail-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-ml-film-toggle]');
      if (!video || !button) return;

      this.video = video;
      this.button = button;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const label = button.querySelector('[data-ml-film-label]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.halfVisible = false;
      this.autoAttempted ??= false;
      this.userPaused ??= false;
      this.resumeWhenVisible ??= false;

      const updateButton = () => {
        const state = video.ended ? 'replay' : video.paused ? 'play' : 'pause';
        const I = window.mlI18n || {}; const text = state === 'replay' ? (I.replayVideo || 'Replay video') : state === 'play' ? (I.playVideo || 'Play video') : (I.pauseVideo || 'Pause video');
        button.dataset.state = state;
        button.setAttribute('aria-label', text);
        if (label) label.textContent = text;
      };

      const play = async () => {
        try {
          await video.play();
          if (signal.aborted) return;
          if (document.hidden || !this.inView) {
            this.resumeWhenVisible = true;
            video.pause();
          }
        } catch {
          if (signal.aborted) return;
          this.resumeWhenVisible = false;
          updateButton();
        }
      };

      const syncVisibility = () => {
        if (document.hidden || !this.inView) {
          if (!video.paused && !video.ended) {
            this.resumeWhenVisible = true;
            video.pause();
          }
          return;
        }
        if (!this.halfVisible || this.userPaused || video.ended) return;
        if (this.resumeWhenVisible) {
          this.resumeWhenVisible = false;
          play();
        } else if (!this.autoAttempted && !reducedMotion.matches && !navigator.connection?.saveData) {
          this.autoAttempted = true;
          play();
        }
      };

      button.addEventListener('click', () => {
        this.autoAttempted = true;
        this.resumeWhenVisible = false;
        if (!video.paused && !video.ended) {
          this.userPaused = true;
          video.pause();
        } else {
          this.userPaused = false;
          if (video.ended) video.currentTime = 0;
          play();
        }
      }, { signal });

      ['play', 'pause', 'ended', 'error'].forEach(event => {
        video.addEventListener(event, updateButton, { signal });
      });
      video.addEventListener('ended', () => {
        this.resumeWhenVisible = false;
      }, { signal });
      document.addEventListener('visibilitychange', syncVisibility, { signal });

      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.loop = this.classList.contains('ml-gallery-film');
      if (!video.loop) video.removeAttribute('loop');
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      button.hidden = false;
      updateButton();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          if (signal.aborted) return;
          this.inView = entry.isIntersecting && entry.intersectionRatio > 0;
          this.halfVisible = entry.intersectionRatio >= 0.5;
          syncVisibility();
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
      } else {
        // Older browsers retain manual playback rather than guessing visibility.
        this.inView = true;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.controller?.abort();
      this.controller = null;
      if (this.video) {
        this.resumeWhenVisible = !this.userPaused && !this.video.ended &&
          (this.resumeWhenVisible || !this.video.paused);
        this.video.pause();
        this.video.controls = true;
      }
      if (this.button) this.button.hidden = true;
    }
  });
}
